import React from "react";

const WBOTreasureBonds = () => {
  return <div>WBOTreasureBonds WBOTreasureBonds</div>;
};

export default WBOTreasureBonds;
